import { z } from "zod";

/** Shared transport primitives for the two customs-report modals. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const optionalCustomsTextSchema = z.string().trim().optional().default("");

export const optionalPositiveCustomsDecimalSchema = optionalCustomsTextSchema.refine(
  value => value === "" || (/^\d+(?:\.\d+)?$/.test(value) && Number(value) > 0),
  { message: "Enter a positive number" },
);
